/** @format */
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CustomStudyDraft } from 'common-typescript/types';

@Component({
    selector: 'app-student-custom-study-draft-info',
    templateUrl: './student-custom-study-draft-info.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class StudentCustomStudyDraftInfoComponent {
    @Input() studyDraft: CustomStudyDraft;
    @Input() isSuggestButtonVisible: boolean;
    @Output() close = new EventEmitter<void>();
    @Output() suggestAttainment = new EventEmitter<void>();
}
